import * as React from 'react';

import { ChatMessageMeta } from '../../../../components/ChatMessageMeta';
import { CHATBOT_ID } from '../../../../constants/chatbotId';
import { useMessageContext } from '../../../../utils/messageContext';
import { EOutcomingStatus } from '../../../../types/messages';
import { EMessageType } from '../../../../types/messageType';
import { EUserColor } from '../../../../types/userName';
import { TColors } from '@cian/ui-kit-design-tokens/colors';
import { getStatusIcon } from '../../../ChatMessageContainer/utils';

export const ChatMessageMetaContainer: React.FC = () => {
  const { message, messageType, userColor, chatId } = useMessageContext();
  const { status, created, isOutcoming, offers, isDeleted } = message;

  const isOfferMessage = offers && offers.length > 0;
  const isChatbotOfferMessage = chatId === CHATBOT_ID && isOfferMessage && !isOutcoming;

  const statusIcon = React.useMemo(
    () => (isOutcoming && status !== EOutcomingStatus.Failed && !isDeleted ? getStatusIcon(status) : null),
    [isOutcoming, status, isDeleted],
  );

  if (isChatbotOfferMessage) {
    return null;
  }

  const metaColor: TColors =
    userColor === EUserColor.Purple
      ? 'overlay-default'
      : messageType === EMessageType.Outcoming
        ? 'text-inverted-default'
        : 'text-secondary-default';

  return <ChatMessageMeta created={created} statusIcon={statusIcon} color={metaColor} />;
};
